import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { getEntities } from '../utils/getEntities';
import { ISystem, ISystemDAO, ISystemService } from 'types/domain/system';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?) => id || state.state[EntityTypes.SYSTEM];

export const selectSystem = createSelector([entity, id], parseSystemDAO);

export function parseSystemDAO(entity, id) {
  const system = entity[EntityTypes.SYSTEM][id];

  if (!system) return null;

  return {
    ...system,
    attributes: getEntities(entity, EntityTypes.SYSTEM_ATTRIBUTE, 'systemId', id),
    services: getEntities(entity, EntityTypes.SYSTEM_SERVICE, 'systemId', id)
  } as ISystemDAO;
}
